module.exports = __webpack_public_path__ + "static/media/quidditch.c3bcdb66.svg";